import api from 'api';

export const loadMainBudgetPlanningGrid = api(
  'GET /api/main-budget-planning/grid'
);

export const createMainBudgetPlanning = api('POST /api/main-budget-planning');

export const loadMainBudgetPlanning = api('GET /api/main-budget-planning/:id');

export const editMainBudgetPlanning = api('PUT /api/main-budget-planning/:id');

export const removeMainBudgetPlanning = api(
  'DELETE /api/main-budget-planning/:id'
);

export const exportMainBudgetPlanning = api(
  'POST /api/main-budget-planning/export'
);

export const importMainBudgetPlanning = api(
  'POST /api/main-budget-planning/import'
);
